import { render } from "./AddTypeCompteModal.vue?vue&type=template&id=5b9b41c8&ts=true"
import script from "./AddTypeCompteModal.vue?vue&type=script&lang=ts"
export * from "./AddTypeCompteModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__